import { render, staticRenderFns } from "./templateB.vue?vue&type=template&id=01ba9a94&scoped=true&"
import script from "./templateB.vue?vue&type=script&lang=js&"
export * from "./templateB.vue?vue&type=script&lang=js&"
import style0 from "./templateB.vue?vue&type=style&index=0&id=01ba9a94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ba9a94",
  null
  
)

export default component.exports